import "./index.css";
import Home from "./routes/Home";
import Projects from "./routes/Projects";
import About from "./routes/About";
import Contact from "./routes/Contact";
import { Route, Routes } from "react-router-dom";

function App() {
  return (
    <>
    <Routes>
      <Route path="/" element= {<Home/>}></Route>
      <Route path="/Projects" element= {<Projects/>}></Route>
      <Route path="/About" element= {<About/>}></Route>
      <Route path="/Contact" element= {<Contact/>}></Route>

    </Routes>
    </>

  );
}

export default App;